import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';

import { SpinnerService } from '@app/core/services/root';
import { ISpinnerState } from '@app/interfaces';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit, OnDestroy {
    public show = false;
    public displayCancel = false;
    private subscription: Subscription;
    private uploadSubscription: Subscription;
    public currentUpload = 0;
    public totalDocs = 0;
    public fileName = '';
    public uploadProgress = 0;


    constructor(
        private changeDetector: ChangeDetectorRef,
        private spinnerService: SpinnerService
        ) { }

    ngOnInit() {
        this.subscription = this.spinnerService.getSpinnerState()
            .subscribe((state: ISpinnerState) => {
                this.show = state.show;
                this.displayCancel = state.displayCancel;
            });
    }

    ngAfterViewChecked() {
        this.changeDetector.detectChanges();
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        if (this.uploadSubscription) {
            this.uploadSubscription.unsubscribe();
        }
    }

    public cancelUploads(): void {
        this.spinnerService.cb();
    }
}
